import { render, staticRenderFns } from "./TipDialog.vue?vue&type=template&id=1b36ea4c&scoped=true&"
import script from "./TipDialog.vue?vue&type=script&lang=ts&"
export * from "./TipDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TipDialog.vue?vue&type=style&index=0&id=1b36ea4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36ea4c",
  null
  
)

export default component.exports